// empty file prevent babel-plugin-import error
import 'choerodon-ui/lib/style/index.less';
